import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { BackofficeSessionService } from './backoffice-session.service';
import {
  BackofficeTournamentRegistrationResponse,
  BackofficeTournamentRegistrationsResponse
} from './backoffice-tournament-registrations-api.types';

@Injectable({ providedIn: 'root' })
export class BackofficeTournamentRegistrationsApiService {
  private readonly http = inject(HttpClient);
  private readonly session = inject(BackofficeSessionService);
  private readonly apiBaseUrl = environment.apiBaseUrl;

  list(tournamentId: number): Observable<BackofficeTournamentRegistrationsResponse> {
    return this.http.get<BackofficeTournamentRegistrationsResponse>(
      `${this.apiBaseUrl}/api/backoffice/tournaments/${tournamentId}/registrations`,
      { headers: this.authHeaders() }
    );
  }

  decide(
    tournamentId: number,
    registrationId: number,
    status: string,
    reason?: string | null
  ): Observable<BackofficeTournamentRegistrationResponse> {
    return this.http.post<BackofficeTournamentRegistrationResponse>(
      `${this.apiBaseUrl}/api/backoffice/tournaments/${tournamentId}/registrations/${registrationId}/decision`,
      { decision: { status, reason } },
      { headers: this.authHeaders() }
    );
  }

  checkIn(tournamentId: number, registrationId: number): Observable<BackofficeTournamentRegistrationResponse> {
    return this.http.post<BackofficeTournamentRegistrationResponse>(
      `${this.apiBaseUrl}/api/backoffice/tournaments/${tournamentId}/registrations/${registrationId}/check-in`,
      {},
      { headers: this.authHeaders() }
    );
  }

  runWheel(tournamentId: number): Observable<BackofficeTournamentRegistrationsResponse> {
    return this.http.post<BackofficeTournamentRegistrationsResponse>(
      `${this.apiBaseUrl}/api/backoffice/tournaments/${tournamentId}/registrations/run-wheel`,
      {},
      { headers: this.authHeaders() }
    );
  }

  updateSeed(
    tournamentId: number,
    registrationId: number,
    seedNumber: number | null
  ): Observable<BackofficeTournamentRegistrationResponse> {
    return this.http.patch<BackofficeTournamentRegistrationResponse>(
      `${this.apiBaseUrl}/api/backoffice/tournaments/${tournamentId}/registrations/${registrationId}/seed`,
      { registration: { seed_number: seedNumber } },
      { headers: this.authHeaders() }
    );
  }

  updateManualSlot(
    tournamentId: number,
    registrationId: number,
    manualSlotNumber: number | null
  ): Observable<BackofficeTournamentRegistrationResponse> {
    return this.http.patch<BackofficeTournamentRegistrationResponse>(
      `${this.apiBaseUrl}/api/backoffice/tournaments/${tournamentId}/registrations/${registrationId}/manual-slot`,
      { registration: { manual_slot_number: manualSlotNumber } },
      { headers: this.authHeaders() }
    );
  }

  private authHeaders(): HttpHeaders {
    const token = this.session.token();
    return token ? new HttpHeaders({ Authorization: `Bearer ${token}` }) : new HttpHeaders();
  }
}
